const RESOURCE_TYPES_ARRAY = [
  "data",
  "job",
  "service",
  "account",
  "user",
  "role",
] as const;

export type ResourceType = (typeof RESOURCE_TYPES_ARRAY)[number];
const RESOURCE_TYPES = new Set<string>(RESOURCE_TYPES_ARRAY);

export { RESOURCE_TYPES_ARRAY };

export function toResourceType(
  value: string | undefined | null,
): ResourceType | undefined {
  return value && RESOURCE_TYPES.has(value)
    ? (value as ResourceType)
    : undefined;
}

export const RESOURCE_NAME_FIELD: Record<ResourceType, "fullName" | "name"> = {
  data: "fullName",
  job: "name",
  service: "fullName",
  account: "fullName",
  user: "fullName",
  role: "fullName",
};
